import {
   ComponentFactoryResolver,
   ComponentRef,
   Directive,
   Input,
   OnChanges,
   OnDestroy,
   ViewContainerRef,
} from '@angular/core';
import { NgChanges } from 'src/lib/ng-changes';
import { DashboardTile } from '../../../dashboard/models/dashboard-tile.model';
import { TileDataUnion } from '../../models/tile-data.model';
import { TileParametersBase } from '../../models/tile-parameters.model';
import { TileBase } from '../../views/shared/tile-base';
import { TileComponentAccessor } from './tile-component-accessor';

@Directive({
    selector: '[ndtDynamicTile]',
    standalone: false
})
export class DynamicTileDirective implements OnChanges, OnDestroy {
   @Input() tileConfig: DashboardTile;

   @Input() componentAccessor: TileComponentAccessor;

   @Input() isFullscreen: boolean = false;

   @Input() isEditing: boolean = false;

   @Input() showHeader: boolean = true;

   @Input() isPreview: boolean = false;

   component: ComponentRef<TileBase<TileParametersBase, TileDataUnion>> | null = null;

   constructor(
      private componentFactoryResolver: ComponentFactoryResolver,
      private viewContainerRef: ViewContainerRef
   ) {}

   ngOnChanges(changes: NgChanges<DynamicTileDirective>): void {
      const loadedWithNoComponent = !this.component;
      if (loadedWithNoComponent || changes.tileConfig) {
         this.destroyComponents();
         const componentType = this.componentAccessor(this.tileConfig);
         const component = this.componentFactoryResolver.resolveComponentFactory(componentType);
         this.component = this.viewContainerRef.createComponent(component);
      }
      if (
         loadedWithNoComponent ||
         changes.isFullscreen ||
         changes.isEditing ||
         changes.showHeader ||
         changes.tileConfig
      ) {
         if (this.component) {
            this.component.instance.tileConfig = { ...this.tileConfig };
            this.component.instance.isFullscreen = this.isFullscreen;
            this.component.instance.isEditing = this.isEditing;
            this.component.instance.showHeader = this.showHeader;
            this.component.instance.isPreview = this.isPreview;
            this.component.instance.changeDetectorRef.detectChanges();
         }
      }
   }

   ngOnDestroy(): void {
      this.destroyComponents();
   }

   private destroyComponents(): void {
      if (this.component) {
         this.component.destroy();
      }
   }
}
